import React from 'react'
import PropTypes from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'

import AdvertiseHeader from '@/component/Primitive/AdvertiseHeader'

const AdvertiseHeroWidget = ({ images, lightLogoUrl, instanceName }) => {
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]

  const largeSrcSet = [
    {
      width: 600,
      src: changeFileExtension(getImage('desktop', '72x29', 600)?.url, 'webp')
    },
    {
      width: 800,
      src: changeFileExtension(getImage('desktop', '72x29', 800)?.url, 'webp')
    },
    {
      width: 1048,
      src: changeFileExtension(getImage('desktop', '72x29', 1048)?.url, 'webp')
    }
  ]
  const smallSrcSet = [
    {
      width: 400,
      src: changeFileExtension(getImage('mobile', '320x287', 400)?.url, 'webp')
    },
    {
      width: 600,
      src: changeFileExtension(getImage('mobile', '320x287', 600)?.url, 'webp')
    }
  ]

  const sizes = [
    '(min-width: 1176px) 1048px',
    '(min-width: 946px) calc(100vw - 128px)',
    'calc(100vw - 64px)'
  ]

  const image = {
    desktop: {
      sizes: sizes,
      srcSet: largeSrcSet,
      src: getImage('desktop', '72x29', 1048)?.url
    },
    mobile: {
      sizes: sizes,
      srcSet: smallSrcSet,
      src: getImage('mobile', '320x287', 600)?.url
    }
  }
  const brand = {
    logo: lightLogoUrl,
    name: instanceName
  }

  return <AdvertiseHeader brand={brand} image={image} />
}

AdvertiseHeroWidget.propTypes = {
  lightLogoUrl: PropTypes.string,
  instanceName: PropTypes.string,
  images: PropTypes.object.isRequired
}

export default AdvertiseHeroWidget
